import { Urls } from '../../../Shared/Api';

export default class CouponsCarouselService {
    static getCoupons() {
        return fetch(Urls.coupons.getData)
            .then((res) => {
                return res.json();
            });
    }
}


// WEBPACK FOOTER //
// ./Src/Components/Coupons/CouponsCarousel/CouponsCarouselService.js